export default "__VITE_ASSET__D7g1XhdP__"